import { ColumnApi, GridApi } from 'ag-grid-community'
import { TableProps } from './Table'
import isEqual from 'lodash/isEqual'
import localForage from 'localforage'

const store = localForage.createInstance({
  name: 'persist-table-state',
})

// Uses cookies to store the state of a given table accross different dimensions

type PersistType = TableProps['persistStateForDimensions'] & {}

// It's obviously not unique, but let's face it, there won't be conflicts
const getKeyName = ({ tableName, ...rest }: PersistType) =>
  `table-${tableName}--` +
  Object.entries(rest)
    .map(e => e.join('-'))
    .join('--')

export const persistTableState = (gridApi: GridApi, columnApi: ColumnApi, persistState: PersistType) => {
  const state = {
    columnState: columnApi.getColumnState(),
    filterModel: gridApi.getFilterModel(),
    sortModel: gridApi.getSortModel(),
    pinned: columnApi
      .getAllColumns()
      .filter(e => e.isPinned())
      .map(e => ({
        colId: e.getColId(),
        pinned: e.getPinned(),
      })),
  }

  store.setItem(getKeyName(persistState), state)
}

export const getTableState = (persistState: PersistType) => store.getItem(getKeyName(persistState))

export const restoreTableState = (gridApi: GridApi, columnApi: ColumnApi, result: any) => {
  if (result) {
    const state = columnApi.getColumnState()
    const columnIds = { ...state.map(e => ({ [e.colId]: true })) }
    const { sortModel, filterModel, columnState, pinned } = result
    sortModel && gridApi.setSortModel(sortModel)
    filterModel && gridApi.setFilterModel(filterModel)
    if (columnState) {
      // Reject the state in the store if the columns no longer exist
      const newState = [...columnState, ...state.filter((e: any) => !columnIds[e.colId])]
      // Only update the state if there's a difference
      !isEqual(newState, state) && columnApi.setColumnState(newState)

      // hidden columns aren't hidden properly. Hide them manually
      columnApi.setColumnsVisible(
        newState.filter(e => e.hide).map(c => c.colId),
        false
      )
    }
    ;(pinned || []).forEach((e: { colId: string; pinned: string }) => columnApi.setColumnPinned(e.colId, e.pinned))
  }
  return result
}

export const resetTableState = (persistState: PersistType) => store.removeItem(getKeyName(persistState))
